import { theme } from '@/utils/theme';
import type { ColorParams, Variant } from './types';

export const classes = {
  wrapper:
    'relative inline-flex items-center justify-center rounded-lg overflow-hidden',
  border: 'border',
  wrapperLarge: 'p-3 rounded-xl',
  wrapperBase: 'p-2 group-data-[compact]/tile:p-1',
  wrapperSmall: 'p-1',
  wrapperExtraSmall: 'p-0.5 rounded-md',
  gradientFilter:
    'absolute top-0 left-0 size-full bg-gradient-to-br from-white/50 to-70% to-white/0 mix-blend-luminosity',
  // 'hidden',
  icon: 'z-10 select-none',
  iconLarge: 'text-4xl',
  iconBase: 'text-2xl group-data-[compact]/tile:text-lg',
  iconSmall: 'text-xl',
  iconExtraSmall: 'text-lg',
};

export const styles = {
  wrapper: (variant: Variant, colors: ColorParams) => ({
    color: theme.palette[colors.color].main,
    backgroundColor:
      variant === 'contained'
        ? theme.palette[colors.backgroundColor].main
        : 'transparent',
    borderColor:
      variant === 'text' || colors.borderColor === null
        ? 'transparent'
        : theme.palette[colors.borderColor].main,
  }),
};
